import type { ProviderContentProps } from '@smart-tv/hooks/use-ui-element-content/use-ui-element-content';
import { UIElementContent, UIElementStyle } from '@smart-tv/typings/content';

import { toSortingType, toUIElementContent } from './helpers';
import { kmm } from './kmm';

export async function getProviderCollectionContentList(
  payload: ProviderContentProps,
  style: UIElementStyle
): Promise<UIElementContent> {
  const {
    universeId,
    mainGenreId,
    subGenreId,
    providerCollectionId,
    itemLimit,
    sortingType,
    start
  } = payload;

  const result = await kmm((repo) =>
    repo.getProviderCollectionContentList(
      start ?? 0,
      itemLimit,
      universeId,
      toSortingType(sortingType),
      mainGenreId,
      subGenreId,
      providerCollectionId ?? 0
    )
  );

  return toUIElementContent(result, style);
}

export default getProviderCollectionContentList;
